<template>
  <div class="pump-marker" :class="status">
    <svg
      t="1732675201495"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5249"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <path
        d="M512 122.88c-214.528 0-389.12 174.592-389.12 389.12s174.592 389.12 389.12 389.12 389.12-174.592 389.12-389.12-174.592-389.12-389.12-389.12z m0 716.8c-180.736 0-327.68-146.944-327.68-327.68s146.944-327.68 327.68-327.68 327.68 146.944 327.68 327.68-146.944 327.68-327.68 327.68z"
        p-id="5250"
      ></path>
      <path
        d="M512 512m-143.36 0a143.36 143.36 0 1 0 286.72 0 143.36 143.36 0 1 0-286.72 0Z"
        p-id="5251"
      ></path>
    </svg>
    <div class="pump-marker__title">
      <div>{{ data.name }}</div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import store from "@/store";
import { toFixed, getUnit } from "@/components/models/utils";
import router from "@/router";

const props = defineProps({
  data: {
    type: Object,
  },
});

const devices = computed(() => {
  return (
    store.state.devices.find((i) => i.code === props.data.id)?.sensors || []
  );
});

const status = computed(() => {
  const isProcess = router.currentRoute.name === "水厂工艺";
  const sensors =
    store.state.devices.find((i) => i.code === props.data.id)?.sensors || [];
  const yx = getValue(sensors.find((i) => i.unit === "YX"));
  const gz = getValue(sensors.find((i) => i.unit === "GZ"));

  return (
    (isProcess ? "process " : "") +
    (gz === "故障"
      ? "pump-marker__err"
      : yx === "停止"
      ? "pump-marker__off"
      : "pump-marker__on")
  );
});

const getValue = (sensor) => {
  return toFixed(sensor.o_realtime?.value, sensor.o_unit);
};
</script>

<style scoped lang="less">
.pump-marker {
  width: 30px;
  height: 30px;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }

  &__title {
    position: fixed;
    top: 0;
    right: -30px;
    width: auto;
    height: 30px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    display: flex;
    align-items: center;
    margin: 0 -20px;
    box-sizing: border-box;
    font-family: DINCond-Black, sans-serif;
    font-weight: bold;
    text-shadow: 2px 2px 4px #000;

    div {
      padding: 0 10px;
    }
  }

  &.process {
    width: 30px;
    height: 30px;

    .pump-marker__title {
      right: -40px;
      height: 30px;
      font-size: 18px;
    }
  }

  &__err {
    svg {
      fill: yellow;
    }

    .pump-marker__title {
      background: rgba(255, 255, 0, 0.5);
    }
  }

  &__off {
    svg {
      fill: red;
    }

    .pump-marker__title {
      background: rgba(255, 0, 0, 0.5);
    }
  }

  &__on {
    svg {
      fill: #59f720;
    }

    .pump-marker__title {
      background: rgba(89, 247, 32, 0.5);
    }
  }
}
</style>
